export const AREA_INPUT_VALUE_PATTERN = /^(?:\d+(?:[.,]\d*)?)?$/;
